<template>
  <tabbar-item v-if="trialPrograms.length !== 0"
               class="audio-program-trail-btn"
               :disabled="disabled"
               @click="handleClick"
  >
    <ym-icon class="icon-play-control"
              :name="playingCurrent ? 'round-pause': 'round-play'"
    />
    <span>试听</span>
  </tabbar-item>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PlayerPlaylistStorageMixin from '@/mixins/player/playerPlaylistStorage';
  import TabbarItem from '@/components/YmTabbarItem';

  export default {
    name: 'AudioProgramTrialBtn',
    mixins: [PlayerPlaylistStorageMixin],
    components: {
      TabbarItem,
    },
    data() {
      return {
        disabled: false,
      };
    },
    props: {
      trialPrograms: {
        type: Array,
        required: true,
      },
    },
    computed: {
      ...mapGetters([
        'player',
      ]),
      playingCurrent() {
        const { player, trialPrograms } = this;
        const { playingId } = player;
        return trialPrograms.find(item => item.id === playingId);
      },
    },
    methods: {
      handleClick() {
        this.disabled = true;
        const { trialPrograms, player } = this;

        // 正在播放当前音频，则暂停
        if (this.playingCurrent) {
          player.pause();
          this.disabled = false;
          return;
        }

        try {
          this.setGlobalPlayerInfo(trialPrograms, true, false);
          player.play();
          this.disabled = false;
        } catch (e) {
          this.disabled = false;
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .audio-program-trail-btn {
    line-height: 1;
    white-space: nowrap;
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: @trail-program-size;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: @font-size-extra-small;
    position: relative;

    .icon-play-control {
      font-size: 38px;
      color: @color-text-base;
      margin-bottom: @size-extra-small;
    }
  }
</style>
